import React, { useState } from "react";
import OBCustomRadioButton from "../OBCustomRadioButton";
import multiUserLight from "../../../../assets/multi-user-light.svg";
import userLight from "../../../../assets/user_light.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { usePostSupplierSaveTypeMutation } from "../../../../rtk-query/slices/onboarding/supplierTypeSlice";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useGetUserProfileQuery } from "../../../../rtk-query/slices/profile/profileSlice";

function SupplierTypeTabContent({ setCurrentTab }) {
  const navigate = useNavigate();
  const [postSupplierSaveType, { isLoading }] =
    usePostSupplierSaveTypeMutation();

  const { data: userProfile } = useGetUserProfileQuery();

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      option: userProfile?.data?.supplier?.supplier_type || null, // Radio button value
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      option: Yup.string().required("Please select an option"),
    }),
    onSubmit: async (values, { resetForm, setFieldError }) => {
      try {
        const data = {
          supplier_type: values.option,
        };
        const response = await postSupplierSaveType(data);

        if (response?.data?.status) {
          toast.success(response?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
          setCurrentTab(2);
        }
        if (response?.error) {
          const errors = response?.error?.data?.errors;
          if (response?.error?.status == 401) {
            localStorage.removeItem("DODLoginToken");
            toast.error(response?.error?.data.message, {
              position: "top-center",
              autoClose: 3000,
            });
            navigate("/login");
          } else if (errors) {
            for (const field in errors) {
              if (errors.hasOwnProperty(field)) {
                const combinedErrors = errors[field].join(" ");
                if (field === "supplier_type") {
                  setFieldError("option", combinedErrors);
                }
              }
            }
            toast.error(response?.error?.data.message, {
              position: "top-center",
              autoClose: 3000,
            });
          } else {
            toast.error(response?.error?.data.message, {
              position: "top-center",
              autoClose: 3000,
            });
          }
        }
      } catch (error) {
        console.log("Errors:", error);
        toast.error("An unexpected error occurred. Please try again.");
      }
    },
  });

  return (
    <section className="ob-supplier-content-body">
      <h1 className="ob-supplier-content-heading mt-4">
        Are you a company or a freelancer?
        <span className="text-danger ps-1">*</span>
      </h1>
      <form onSubmit={formik.handleSubmit}>
        <div className="mt-4 ob-supplier-content-form">
          <OBCustomRadioButton
            id="option1"
            name="option"
            value="Company"
            checked={formik.values.option === "Company"}
            onChange={formik.handleChange}
            icon={multiUserLight} // Example icon
            text1="Yes, I am a representative of a registered company"
            text2="Choose this if your company is registered under a govt law of incorporation"
            tooltipText="choose the option as your business type. This shall be used for correspondence"
            disabled={false}
          />
          <OBCustomRadioButton
            id="option2"
            name="option"
            value="Freelancer"
            checked={formik.values.option === "Freelancer"}
            onChange={formik.handleChange}
            icon={userLight} // Example icon
            text1="No, I am a freelancer"
            text2="You are doing this business as a freelancer or as a broker and doesn't represent a company"
            tooltipText="choose the option as your business type. This shall be used for correspondence"
            disabled={true}
          />
          {formik.touched.option && formik.errors.option ? (
            <div className="error-text invalid-feedback d-flex">
              {formik.errors.option}
            </div>
          ) : null}
          <div className="d-flex align-items-center justify-content-end mt-4">
            <button disabled={isLoading} type="submit" className="submit-btn">
              Save & Continue {isLoading && <Spinner size="sm" />}
            </button>
          </div>
        </div>
      </form>
    </section>
  );
}

export default SupplierTypeTabContent;
